import { Button, Text } from '@react-spectrum/s2';
import ChevronRight from '@react-spectrum/s2/icons/ChevronRight';

import { useConfettiBurst } from './useConfettiBurst';

type JobStartedScreenProps = {
	onContinue: () => void;
};

const ACCENT = '#2D5F4F';

export const JobStartedScreen = ({ onContinue }: JobStartedScreenProps) => {
	const confettiHostRef = useConfettiBurst();

	return (
		<div className="flex h-full w-full items-center justify-center">
			<div
				className="flex flex-col items-center px-8 text-center"
				style={{ maxWidth: 560 }}
			>
				<div
					className="relative mb-5 flex items-center justify-center"
					style={{ width: 96, height: 96 }}
				>
					<div
						style={{
							width: 80,
							height: 80,
							background: 'rgba(45, 95, 79, 0.10)',
							borderRadius: '50%',
							position: 'relative',
							zIndex: 2,
						}}
					>
						<svg
							viewBox="0 0 80 80"
							width="80"
							height="80"
							style={{ display: 'block' }}
						>
							<circle
								className="onb-success-check-circle"
								cx="40"
								cy="40"
								r="36"
								fill="none"
								stroke={ACCENT}
								strokeWidth={3}
								strokeLinecap="round"
							/>
							<path
								className="onb-success-check-tick"
								d="M24 41 L36 53 L57 30"
								fill="none"
								stroke={ACCENT}
								strokeWidth={4.5}
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
						</svg>
					</div>
					<div
						ref={confettiHostRef}
						aria-hidden="true"
						style={{
							position: 'absolute',
							top: '50%',
							left: '50%',
							width: 0,
							height: 0,
							pointerEvents: 'none',
							zIndex: 1,
						}}
					/>
				</div>

				<h2
					className="onb-success-text-in mb-3"
					style={{
						fontSize: 30,
						fontWeight: 700,
						letterSpacing: '-0.02em',
						color: ACCENT,
						animationDelay: '800ms',
					}}
				>
					Job started
				</h2>

				<p
					className="onb-success-text-in mb-8"
					style={{
						fontSize: 16,
						lineHeight: 1.5,
						color: 'var(--text-primary)',
						maxWidth: 440,
						animationDelay: '950ms',
					}}
				>
					I&apos;ll start running this once we finish onboarding. You&apos;ll
					see results on your home screen as they come in.
				</p>

				<div
					className="onb-success-text-in"
					style={{ animationDelay: '1150ms' }}
				>
					<Button
						variant="primary"
						staticColor="black"
						fillStyle="fill"
						size="L"
						onPress={onContinue}
					>
						<Text>Continue</Text>
						<ChevronRight />
					</Button>
				</div>
			</div>
		</div>
	);
};
